import React from 'react';
import PropTypes from 'prop-types';
import ClipboardJS from 'clipboard';
import Notification, {
  Success as NotificationSuccess,
} from 'library/components/notification';
import KeyCodes from '../helpers/key-codes';

class CopyButton extends React.Component {
  static propTypes = {
    value: PropTypes.string.isRequired,
    notification: PropTypes.string,
    tooltip: PropTypes.string,
    disabled: PropTypes.bool,
  };

  static defaultProps = {
    component: 'button',
    className: 'button-outline-inherit',
  };

  constructor(...params) {
    super(...params);

    this.buttonRef = React.createRef();
  }

  componentDidMount() {
    this.clipboard = new ClipboardJS(this.buttonRef.current, {
      text: () => this.props.value,
    });

    this.clipboard.on('success', this.handleSuccess);
  }

  handleSuccess = () => {
    Notification.new(
      { timeout: 1500 },
      <NotificationSuccess>
        {this.props?.notification || 'Successfully Copied to Clipboard'}
      </NotificationSuccess>
    );
  };

  handleKeyPress = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (
      KeyCodes.POSITIVE_AFFIRMATIONS.includes(e.which) &&
      !this.props.disabled
    ) {
      this.clipboard.onClick(e);
    }
  };

  render() {
    if (!ClipboardJS.isSupported()) {
      return null;
    }

    const { component: Component, value, isTabbing, ...props } = this.props;

    return (
      <Component
        tabIndex={0}
        onKeyUp={this.handleKeyPress}
        onClick={this.copy}
        ref={this.buttonRef}
        {...props}
      >
        {this.props.children || 'COPY'}
      </Component>
    );
  }
}

export default CopyButton;
